import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericOrderDetail } from "src/app/domain/models/ImportOrder";

@Injectable({providedIn: 'root'})
export abstract class GenericOrderDetailGateway {
  abstract getAllPendingForQCReviews(): Observable<GenericOrderDetail[]>
  abstract getAllReviewedOriginQCReviews(): Observable<GenericOrderDetail[]>
}
